// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasObjectsAlignCenterHorizontal: CreateIconOptions = {
  "displayName": "FASObjectsAlignCenterHorizontal",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 0c-13.3 0-24 10.7-24 24l0 40L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l152 0 0 64-88 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l88 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 88 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-88 0 0-64 152 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L280 64l0-40c0-13.3-10.7-24-24-24z"
};
